import './_navigation-menu-button.scss';

export default () => {};
